<template>
  <div
    class="d-flex-column justify-start align-start"
    :class="[steps.length > 0 && 'gap-24']"
  >
    <div class="d-flex-row gap-0">
      <div class="range-slider">
        <div class="progress" ref="progress"></div>
        <input
          type="range"
          :min="min"
          :max="max"
          v-model="sliderValue"
          :step="step"
          ref="sliderInput"
        />
      </div>
    </div>
    <div class="d-flex-row space-between" v-if="steps.length > 0">
      <label
        class="t-white medium-xl font-family-2"
        v-for="(step, index) in steps"
        :key="step"
        :class="[index === 0 || index === steps.length - 1 ? '' : 'md-hide']"
        >{{ step?.title }}</label
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderValue: 70,
    };
  },
  props: {
    steps: {
      default: [
        {
          title: "0",
        },
        {
          title: "10k",
        },
        {
          title: "20k",
        },
        {
          title: "30k",
        },
        {
          title: "40k",
        },
        {
          title: "50k",
        },
        {
          title: "60k",
        },
      ],
    },
    min: {
      default: 0,
    },
    max: {
      default: 70,
    },
    modelValue: {
      default: null,
    },
    step: {
      default: 1,
    },
  },
  mounted() {
    // Initialize safely within bounds
    const initialValue = this.modelValue || this.min;
    // Ensure initial value is within min-max range
    this.sliderValue = Math.max(this.min, Math.min(this.max, initialValue));

    // Update progress bar on mount
    this.$nextTick(() => {
      this.updateProgressBar();
    });
  },
  methods: {
    updateProgressBar() {
      if (this.$refs?.progress?.style) {
        // Ensure value is within bounds for calculation
        const boundedValue = Math.max(
          this.min,
          Math.min(this.max, this.sliderValue)
        );
        const percent =
          ((boundedValue - this.min) / (this.max - this.min)) * 100;

        // Clamp percent between 0 and 100 to prevent overflow
        const clampedPercent = Math.max(0, Math.min(100, percent));

        this.$refs.progress.style.left = "0%";
        this.$refs.progress.style.right = 100 - clampedPercent + "%";
      }
    },
  },
  watch: {
    sliderValue(val) {
      // Ensure value stays within min-max range
      const value = parseInt(val);
      const boundedValue = Math.max(this.min, Math.min(this.max, value));

      // If the value would be out of bounds, correct it
      if (boundedValue !== value) {
        this.$nextTick(() => {
          this.sliderValue = boundedValue;
        });
      }

      // Update progress bar
      this.updateProgressBar();

      // Emit the bounded value
      if (this.modelValue !== boundedValue) {
        this.$emit("update:modelValue", boundedValue);
      }
    },
    modelValue: {
      handler(newVal) {
        if (newVal !== null && newVal !== this.sliderValue) {
          const boundedValue = Math.max(this.min, Math.min(this.max, newVal));
          if (boundedValue !== this.sliderValue) {
            this.sliderValue = boundedValue;

            this.$nextTick(() => {
              if (this.$refs?.sliderInput) {
                this.$refs.sliderInput.value = boundedValue;
              }
              this.updateProgressBar();
            });
          }
        }
      },
      deep: true,
    },
    min(newMin) {
      // If current value is less than new minimum, update to new minimum
      if (this.sliderValue < newMin) {
        this.sliderValue = newMin;
      }
      this.updateProgressBar();
    },
    max(newMax) {
      // If current value is more than new maximum, update to new maximum
      if (this.sliderValue > newMax) {
        this.sliderValue = newMax;
      }
      this.updateProgressBar();
    },
  },
};
</script>
